import { render } from "./Slideshow.vue?vue&type=template&id=1a9284a7&scoped=true&lang=pug"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"

import "./Slideshow.vue?vue&type=style&index=0&id=1a9284a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9284a7"]])

export default __exports__